import {
  BUTTON_ACTIONS,
  MODAL_CONFIGURATION_TYPE,
  NG_SELECT_QUERIES,
} from '../../helpers/ui/ui.constant';
import { DATE_RANGE_PRESETS, TRANSACTION_FILTER_MODES } from '../../helpers/global/global.constant';
import { AGENT_BALANCE_MOMENTS, AGENT_BALANCE_SOURCES } from '../../helpers/global/reports.constant';
import {
  AGENT_OWN_VIEWS,
  AGENT_TRANSACTIONS_MODES,
} from '../../helpers/global/user-management.constant';
import { Affiliate } from '../api/affiliate.interface';
import { AgentNetworkNode } from '../api/transaction.interface';
import { RestrictionSetting } from '../api/restriction-settings.interface';
import { ModalWithAction } from './bootstrap-modal.interface';
import { TranslationsPerLanguage } from './language.interface';

// TODO: do not add more fields, extend the interface please
export interface NgSelect<T> {
  value: T;
  label: string;
  icon?: string;
  group?: string;
  currencyId?: string;
  userType?: string;
  isPhysicalCash?: boolean;
}

export type ButtonAction = (typeof BUTTON_ACTIONS)[keyof typeof BUTTON_ACTIONS];
export type PageConfigurationType =
  (typeof MODAL_CONFIGURATION_TYPE)[keyof typeof MODAL_CONFIGURATION_TYPE];

export type NgSelectQuery = (typeof NG_SELECT_QUERIES)[keyof typeof NG_SELECT_QUERIES];

export interface CustomDateSelector {
  selectedYears?: number[];
  selectMonth?: string[];
  selectedDays?: number[];
  selectWeekDay?: string[];
}

export interface CheckedEventTarget extends Event {
  target: HTMLInputElement;
}

export interface ModalData {
  name: string;
  title: string;
  dataValue: string[];
  [key: string]: any;
}

export interface Select {
  label: string;
  value: string;
}

// TODO: move to a better place (ui constant)
export const TYPE_DATE = {
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year',
};

export interface RestrictionSettingModal extends ModalWithAction<RestrictionSetting> {
  idEntity?: string;
}

export interface CardSocialMedia {
  title: string;
  countClicks: number;
  color?: string;
  icon?: string;
  growth?: string;
  series?: number[];
}

export interface CardStatistics {
  title: string;
  colorClass: string;
  icon: string;
  value: number | null | string;
}

export interface Statistics {
  affiliate: Affiliate[];
  totalCounterClicksResult: [];
  totalPlayersForUser: number;
}

export interface ClickData {
  total: number;
  date: string;
}
export interface GenderData {
  total: number;
  gender: string;
  date: string;
}

export interface CitiesData {
  city: number;
  total: number;
}

export interface BadgeStyleConfig extends TranslationsPerLanguage {
  color: string;
  icon?: string;
}

export interface TranslatedSelectOption<T> {
  label: TranslationsPerLanguage;
  value: T;
}

export interface Breadcrumb {
  title: string;
  items: string[];
  active_item: string;
}

export type Theme = 'light-only' | 'dark-only';
export type ThemeKeys = 'LIGHT_ONLY' | 'DARK_ONLY';
export interface ThemeState {
  value: Theme;
}
export interface CountryPhoneCodeOption extends NgSelect<string> {
  telephoneCode: string;
  icon: string; // este campo lo usaremos como code (ej. ECU, CU)
}

export interface PlayerPermissionItem {
  control: string;
  label: string;
}

export interface PlayerPermissionGroup {
  key: string;
  title: string;
  icon: string;
  summaryTitle: string;
  summaryNote: string;
  description: string;
  permissions: PlayerPermissionItem[];
}

export type DateRangePreset = (typeof DATE_RANGE_PRESETS)[keyof typeof DATE_RANGE_PRESETS];

export type TransactionFilterMode =
  (typeof TRANSACTION_FILTER_MODES)[keyof typeof TRANSACTION_FILTER_MODES];

export interface PlayerTransactionFilterValue {
  startDate: string | null;
  endDate: string | null;
  operationType: string | null;
  transactionOrigin: string | null;
  transactionType: string | null;
  registeredBy: string | null;
  transactionId: string | null;
}

export interface PlayerBlockHistoryFilterValue {
  startDate: string | null;
  endDate: string | null;
  action?: string;
  performedBy?: string[];
}

export interface PlayerChangeHistoryFilterValue {
  startDate?: string;
  endDate?: string;
  status?: string;
  method?: string;
  ip?: string;
  documentId?: string;
  requestId?: string;
  username?: string;
  role?: string;
}

export interface PlayerChangeHistoryFormValue {
  startDate: string;
  endDate: string;
  status: string;
  method: string;
  ip: string;
  documentId: string;
  requestId: string;
  username: string | null;
  role: string | null;
}

export type AgentTransactionsView = (typeof AGENT_OWN_VIEWS)[keyof typeof AGENT_OWN_VIEWS];

export type AgentTransactionsMode =
  (typeof AGENT_TRANSACTIONS_MODES)[keyof typeof AGENT_TRANSACTIONS_MODES];

export interface AgentNetworkBranch {
  nodes: AgentNetworkTreeNode[];
  loaded: number;
  total: number;
  pending: number;
  loading: boolean;
  error: boolean;
  fetched: boolean;
}

export interface AgentNetworkBranches {
  agents: AgentNetworkBranch;
}

export interface AgentNetworkTreeNode {
  data: AgentNetworkNode;
  expanded: boolean;
  branches: AgentNetworkBranches;
}

export type AgentBalanceMoment = (typeof AGENT_BALANCE_MOMENTS)[keyof typeof AGENT_BALANCE_MOMENTS];

export type AgentBalanceSource = (typeof AGENT_BALANCE_SOURCES)[keyof typeof AGENT_BALANCE_SOURCES];
